import { render } from "./Swagger.vue?vue&type=template&id=11f36145"
import script from "./Swagger.vue?vue&type=script&lang=js"
export * from "./Swagger.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__